import React from 'react';

import splash from './img/splash2.jpg'
import cry from './img/cry2.jpg'
import proot from './img/proot2.jpg'
import cover from './img/cover.jpg'

import vaippaText from './img/vaippatext.png'
import vaippaPlain from './img/vaippaplain.png'

import sound1 from './sound/1.mp3'
import sound2 from './sound/2.mp3'
import sound3 from './sound/3.mp3'
import sound4 from './sound/4.mp3'
import sound5 from './sound/5.mp3'
import sound6 from './sound/6.mp3'

import './App.scss';

type TState = 'start' | 'splash' | 'chooser' | 'winning' | 'lost' | 'won'

const audio1 = new Audio(sound1);
const audio2 = new Audio(sound2);
const audio3 = new Audio(sound3);
const audio4 = new Audio(sound4);
const audio5 = new Audio(sound5);
const audio6 = new Audio(sound6);

const App = () => {
  const [state, setState] = React.useState<TState>('start')

  const initialize = () => {
    audio1.play()
    setState('splash')
    window.setTimeout(() => {
      audio2.play()
      setState('chooser')
    }, 3000)
  }

  React.useEffect(() => {
    // initialize()
  }, [])

  const restartButton = <button
    className={'restart'}
    onClick={() => {
      setState('start')
      // initialize()
    }}
  >
    Uudestaan
  </button>

  switch (state) {
    case "start":
      return <div className={'content start'}>
        <button onClick={() => {
          initialize()
        }}>
          Pelaa
        </button>
        <img src={cover} className={'cover'}/>
      </div>
    case "splash":
    // return <div className={'content'}><img className={'splash'} src={splash}/></div>
    case "winning":
    case "chooser":
      return <div className={'content'}>
        <div className={'chooser'}>
          <img className='baby' src={splash}/>
          <div className={'hideable ' + (state === 'splash' ? 'hidden' : '')}>
            <img className={'vaippa'} src={vaippaText}/>
            <img className={'vaippa' + (state === 'winning' ? ' moving' : '')} src={vaippaPlain}/>
            <div className={'buttons'}>
              <button className='first' onClick={() => {
                setState('winning')
                window.setTimeout(() => {
                  audio3.play()
                  setState('won')
                  window.setTimeout(() => {
                    audio5.play()
                  }, 3000)
                }, 3000)
              }}>Kyllä
              </button>
              <button className='second' onClick={() => {
                audio4.play()
                setState('lost')
                window.setTimeout(() => {
                  audio6.play()
                }, 1500)
              }
              }>Ei
              </button>
            </div>
          </div>
        </div>
      </div>
    case "won":
      return <div className={'content center'}>
        <img className='cry' src={cry}/>
        <h3>Voitit pelin</h3>
        {restartButton}
      </div>
    case "lost":
      return <div className={'content center'}>
        <img className='proot' src={proot}/>
        <h3>Hävisit pelin</h3>
        {restartButton}
      </div>
  }
  return <div/>
}

export default App;
